import { useState } from "preact/hooks";
import type { Invoice } from "../../types";
import { Modal } from "../ui/Modal";
import { store } from "../../store/store";
import { toast } from "../shell/Toast";
import { computeInvoiceTotals } from "../../lib/billing";
import { money } from "../../lib/format";

export function RecordPaymentModal({ invoice, onClose, onDone }: { invoice: Invoice; onClose: () => void; onDone: () => void }) {
  const { total, balance } = computeInvoiceTotals(invoice);
  const [amount, setAmount] = useState(String(balance));
  const [error, setError] = useState<string | null>(null);

  function submit(e: Event) {
    e.preventDefault();
    const value = Number(amount);
    if (!value || value <= 0) {
      setError("Enter a payment amount greater than zero.");
      return;
    }
    if (value > balance) {
      setError(`The payment cannot exceed the outstanding balance of ${money(balance)}.`);
      return;
    }
    store.recordPayment(invoice.id, value);
    toast.success(value >= balance ? `${invoice.invoiceNumber} marked as paid.` : `Payment of ${money(value)} recorded.`);
    onDone();
  }

  return (
    <Modal title="Record Payment" onClose={onClose} width={420}>
      <form class="form" onSubmit={submit}>
        {error && <p class="form-error">{error}</p>}
        <div class="invoice-totals" style={{ marginTop: 0 }}>
          <div>
            <span>Invoice total</span>
            <span>{money(total)}</span>
          </div>
          <div>
            <span>Already paid</span>
            <span>{money(invoice.amountPaid)}</span>
          </div>
          <div class="invoice-totals__grand">
            <span>Outstanding</span>
            <span>{money(balance)}</span>
          </div>
        </div>
        <label>
          Payment amount (€)
          <input type="number" min="0" data-ai-id="payment-amount" value={amount} onInput={(e) => setAmount((e.target as HTMLInputElement).value)} />
        </label>
        <div class="form-actions">
          <button type="button" class="btn btn--secondary" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" class="btn btn--primary" data-ai-id="submit-record-payment">
            Record Payment
          </button>
        </div>
      </form>
    </Modal>
  );
}
